const BASE_URL = 'https://api.vmeeting.cn/mr-rest/' //线上环境
//     const BASE_URL = 'https://api.seemeeting.cn/mr-rest/' //测试环境


export default {
    BASE_URL
}